import { render } from "./Failover.vue?vue&type=template&id=810d36be"
import script from "./Failover.vue?vue&type=script&lang=js"
export * from "./Failover.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__